import script from "./AppPaymentLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPaymentLogo.vue?vue&type=script&setup=true&lang=js"

import "./AppPaymentLogo.vue?vue&type=style&index=0&id=6f66db98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f66db98"]])

export default __exports__